import { ServiceDetailPage } from './ServiceDetailPage';

export function InfrastructureServices() {
  return <ServiceDetailPage slug="infrastructure" />;
}
